<template>
    <div class="col-span-full gap-4">

        <QuotaForm :loading="formLoading" :quota="quota" @tableData="updateTable($event)" />

        <Content class="col-span-full" title="subsidized_capacity_list" :showBreadcrumb="false" :showAdd="false">

            <el-table :empty-text="$t('NO_DATA')" :data="tableData.filter((data) => !search || data.amount.includes(search))
                " v-loading="tableLoading" :stripe="true" :default-sort="{ prop: 'id', order: 'descending' }"
                style="width: 100%" max-height="400">
                <el-table-column sortable type="index" :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('INDEX')"
                    width="60">
                    <template slot-scope="scope">
                        <div :data-title="$t('INDEX')">
                            {{ scope.$index + 1 }}
                        </div>
                    </template>
                </el-table-column>


                <el-table-column prop="amount" sortable align="center" :label="$t('amount_fuel_quota')" width="160">
                    <template slot-scope="scope">
                        <div :data-title="$t('amount_fuel_quota')"
                            v-html="$options.filters.numberSeperator(scope.row.amount)">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('DATE_')" width="120">
                    <template slot-scope="scope">
                        <div :data-title="$t('DATE')">
                            {{ scope.row.date | getPersianDate }}
                        </div>
                    </template>
                </el-table-column>


                <el-table-column label="" width="100">
                    <template slot-scope="scope">
                        <div class="fixed-column">
                            <tableFeatures :description="scope.row.description" @remove="remove(scope.row.id)"
                                :title="$t('subsidized_capacity')" @open="open($event)" :view="false" :editLink="false"
                                @edit="edit(scope.row.id)" />
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <Pagination parameter="and" :pagination="{
                count: updatingTable.count,
                current: +$route.query.p,
                request: `histories/company-vehicles/devices/?company_vehicle=${updatingTable.results.length > 0
                    ? updatingTable.results[0].company_vehicle.id
                    : ''
                    }`,
            }" @tableData="updatingTable = $event" @loading="updatingLoading = $event" /> -->
        </Content>
    </div>
</template>
<script>
import QuotaForm from "./QuotaForm.vue";
import Pagination from "@/components/elements/pagination";
import { fuelsQuota, removeFuelQuotas, getFuelQuotas } from "@/api/fuel";
import tableFeatures from "@/components/elements/tableFeatures";
import { open } from "@/mixins/openDesc";
import { gregorianToJalali } from "@/mixins/gregorianToJalali";
import { numberWithSpaces } from "@/mixins/numberWithSpaces";

export default {
    mixins: [open, numberWithSpaces, gregorianToJalali],
    components: {
        QuotaForm,
        tableFeatures,
        Pagination
    },
    data() {
        return {
            tableData: [],
            search: "",
            tableLoading: true,
            quota: null,
            formLoading: false,
        };
    },

    mounted() {
        fuelsQuota.api(this.$route.params.id).then((res) => {
            this.tableLoading = false;
            if (res) {
                this.tableData = res.results;

            }
        });
    },
    methods: {
        remove(id) {
            removeFuelQuotas.api(id).then((res) => {
                if (res) {
                    this.$notify({
                        title: this.$i18n.t("SOMETHING_DELETED", {
                            type: this.$i18n.t("fuel_quota"),
                        }),
                        duration: 4000,
                        customClass: "info_msg",
                    });
                    this.tableData = this.tableData.filter((table) => table.id !== id);
                }
            });
        },
        edit(id) {
            this.formLoading = true;
            this.tableLoading = true;
            getFuelQuotas.api(id).then((res) => {
                this.formLoading = false;
                this.tableLoading = false;
                if (res) {
                    this.quota = res;
                    window.scrollTo({ top: 0, behavior: "smooth" });
                }
            });
        },
        updateTable(data) {
            this.quota = null;
            if (data.type == "add") {
                this.tableData.push({
                    amount: data.amount,
                    id: data.id,
                    date: (data.date)
                });
            } else {
                var updateRow = this.tableData.findIndex((x) => x.id == data.id);
                this.tableData.push({
                    amount: "",
                    date: ''
                });
                this.tableData.pop();
                this.tableData[updateRow] = data;
            }
        },
    },
};
</script>
